module.exports = __webpack_public_path__ + "static/media/Industry.e5b3d629.png";